import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const approveDiscountRequest = createAsyncThunk(
	"discountApproval/approve",
	async ({ requestId, approved_items, general_comments }, { rejectWithValue }) => {
		try {
			const response = await axiosHttp.post(`discount-request/approval/${requestId}/approve`, {
				approved_items,
				general_comments,
			});
			return response.data?.data ?? response.data;
		} catch (error) {
			return rejectWithValue(error.response?.data?.message || "Failed to approve discount request");
		}
	}
);

const DiscountApprovalApproveSlice = createSlice({
	name: "DiscountApprovalApproveSlice",
	initialState: {
		isLoading: false,
		success: false,
		error: null,
		data: null,
	},
	reducers: {
		resetApproveState: (state) => {
			state.isLoading = false;
			state.success = false;
			state.error = null;
			state.data = null;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(approveDiscountRequest.pending, (state) => {
			state.isLoading = true;
			state.success = false;
			state.error = null;
		});
		builder.addCase(approveDiscountRequest.fulfilled, (state, action) => {
			state.isLoading = false;
			state.success = true;
			state.data = action.payload;
		});
		builder.addCase(approveDiscountRequest.rejected, (state, action) => {
			state.isLoading = false;
			state.success = false;
			state.error = action.payload || action.error.message || "Unknown error";
		});
	},
});

export const { resetApproveState } = DiscountApprovalApproveSlice.actions;
export default DiscountApprovalApproveSlice.reducer;
